module.exports = __webpack_public_path__ + "img/icon05.7867b610.png";